import { DriveEta, Report } from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import DirectionsIcon from '@mui/icons-material/Directions';
import GroupsIcon from '@mui/icons-material/Groups';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PhoneIcon from '@mui/icons-material/Phone';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Alert, Box, Divider, Snackbar, Stack, Typography } from '@mui/material';
import { Container } from '@mui/system';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Colors from '../colors';
import Button from '../components/Button';
import CheckboxWithConfirmation from '../components/CheckboxWithConfirmation';
import ControlMeasuresAccordion from '../components/Hazards_ControlMeasures/ControlMeasuresAccordion';
import HazardsAccordion from '../components/Hazards_ControlMeasures/HazardsAccordion';
import InfoContainer from '../components/InfoContainer';
import InfoRow from '../components/InfoRow';
import LoadingSpinner from '../components/LoadingSpinner';
import MultilineInput from '../components/MultilineInput';
import PlusIconButton from '../components/PlusIconButton';
import SimpleRowCard from '../components/SimpleRowCard';
import ModalButton from '../components/modals/Buttons/normal/ModalButton';
import ConfirmationModal from '../components/modals/ConfirmationModal';
import DateSelector from '../components/modals/DatePicker';
import EditMembersModal from '../components/modals/EditMembersModal';
import InstructorsModal from '../components/modals/InstructorsModal';
import LocationModal from '../components/modals/LocationModal';
import ModalContainer from '../components/modals/ModalContainer';
import DoubleTextInputModal from '../components/modals/SafetyTailgateModals/DoubleTextInputModal';
import SingleTextInputModal from '../components/modals/SafetyTailgateModals/SingleTextInputModal';
import TeamModal from '../components/modals/TeamModal';
import TimeSelector from '../components/modals/TimeSelector';

import {
    ADDRESS,
    CONTROL_MEASURES,
    CONTROL_MEASURES_ARRAY,
    DATE,
    DESIGNATED_FIRST_AIDERS,
    EMERGENCY_RESPONSE_PLAN,
    FIRST_AID_KIT_LOCATION,
    HAZARDS,
    HAZARDS_ARRAY,
    INCIDENT,
    INSTRUCTORS,
    LOCAL_GOV_CONTACT,
    LOCATION,
    MUSTER_POINT,
    NAME,
    NEAREST_HOSPITAL,
    NEARMISS_PLACEHOLDER,
    NEAR_MISS,
    PHONE,
    SEARCH_AND_RESCUE,
    SITE_CONTACT,
    START_TIME,
} from '../constants';

import {
    addTeamMembersToFormMembers, createNewDocInDb, deleteFormAndAllRelatedDocuments,
    getAllDocsBySubCollection, getDocByCollectionAndId, getDocsByCollectionAndFK, updateDocByCollectionAndId
} from '../firebase';

import calculateETA from '../utils/BingMaps';

function EditForm({ user, isAdmin }) {
    const navigate = useNavigate();
    const location = useLocation();
    let { formId } = useParams();
    var formData = location.state?.formData;
    // if (formData === undefined) {
    //     formData = {
    //         userId: user.uid,
    //         team: { id: '', name: '', userId: user.uid },
    //         locationName: '',
    //         instructors: [],
    //         timestamp: '',
    //         date: '',
    //         time: '',
    //         notes: '',
    //         hazards: [],
    //         controlMeasures: [],
    //         firstAidLocation: '',
    //         designatedFirstAiders: '',
    //         musterPoint: '',
    //         nearestHospital: { name: '', address: '' },
    //         searchAndRescue: { name: '', phone: '' },
    //         localGovContact: { name: '', phone: '' },
    //         siteContact: { name: '', phone: '' },
    //         nearMissOccurred: false,
    //         incidentOccurred: false,
    //         nearMissDescription: '',
    //         isArchived: false,
    //     }
    // }

    // Current Form Data JSON
    const [form, setForm] = useState(formData);

    // Enables Loading Spinner
    const [isLoading, setIsLoading] = useState(false);

    // All Hazards/Control Measures
    const [allHazards, setAllHazards] = useState(HAZARDS_ARRAY);
    const [allControlMeasures, setAllControlMeasures] = useState(CONTROL_MEASURES_ARRAY);

    // All FormMembers -- For use with MultiSearchSelect component
    const [members, setMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);

    //Incidents
    const [incidents, setIncidents] = useState([])

    // BEGIN: Input Fields Modal Visibility State
    const [dateModalIsVisible, setDateModalIsVisible] = useState(false);
    const [timeModalIsVisible, setTimeModalIsVisible] = useState(false);
    const [locationModalIsVisible, setLocationModalIsVisible] = useState(false);
    const [instructorsModalIsVisible, setInstructorsModalIsVisible] = useState(false);
    const [teamModalIsVisible, setTeamModalIsVisible] = useState(false);

    const [faLocationModalIsVisible, setFaLocationModalIsVisible] = useState(false);
    const [designatedFirstAidersModalIsVisible, setDesignatedFirstAidersModalIsVisible] = useState(false);
    const [musterPointModalIsVisible, setMusterPointModalIsVisible] = useState(false);
    const [nearestHospitalModalIsVisible, setNearestHospitalModalIsVisible] = useState(false);
    const [searchAndRescueModalIsVisible, setSearchAndRescueModalIsVisible] = useState(false);
    const [localGovContactModalIsVisible, setLocalGovContactModalIsVisible] = useState(false);
    const [siteContactModalIsVisible, setSiteContactModalIsVisible] = useState(false);

    const [archiveModalIsVisible, setArchiveModalIsVisible] = useState(false);
    const [deleteModalIsVisible, setDeleteModalIsVisible] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [deleteIncidentModalIsVisible, setDeleteIncidentModalIsVisible] = useState(false);
    // END: Input Fields Modal Visibility State + Saved Input 

    // Set form and whether user is an admin
    useEffect(() => {
        if (!user) return;
        const fetchForm = async () => {
            setIsLoading(true);
            const retrievedForm = await getDocByCollectionAndId('Forms', formId);
            retrievedForm.isArchived = retrievedForm.isArchived || retrievedForm.userId !== user.uid
            setForm(retrievedForm);
            setIsLoading(false);
            if (retrievedForm.isArchived) setSnackbarOpen(true);
            if (retrievedForm.incidentOccurred) {
                const incidents = await getDocsByCollectionAndFK('Incidents', 'formId', formId)
                setIncidents(incidents)
            }
        };
        fetchForm();
    }, [user, formId]);

    // Update the list of displayed Hazards to include custom ones
    useEffect(() => {
        if (allHazards) {
            const updatedAllHazardsSet = new Set([...allHazards, ...form.hazards]);
            const updatedAllHazards = Array.from(updatedAllHazardsSet);
            updatedAllHazards.sort();
            setAllHazards(updatedAllHazards);
        }
        // eslint-disable-next-line
    }, [form.hazards]);

    // Update the list of displayed Control Measures to include custom ones
    useEffect(() => {
        if (allControlMeasures) {
            const updatedAllControlMeasuresSet = new Set([...allControlMeasures, ...form.controlMeasures]);
            const updatedAllControlMeasures = Array.from(updatedAllControlMeasuresSet);
            updatedAllControlMeasures.sort();
            setAllControlMeasures(updatedAllControlMeasures);
        }
        // eslint-disable-next-line
    }, [form.controlMeasures]);

    // Set members for first aiders selector
    useEffect(() => {
        const getMembers = async () => {
            const updatedMembers = await getAllDocsBySubCollection('Forms', formId, 'FormMembers');
            if (updatedMembers.length > 0) {
                const potentialFirstAiders = updatedMembers.map(member => ({
                    firstName: member.firstName,
                    lastName: member.lastName,
                    label: member.firstName + ' ' + member.lastName,
                    value: member.id
                }));
                setMembers(potentialFirstAiders);
                setSelectedMembers(potentialFirstAiders.filter(member => form.designatedFirstAiders.includes(member.label)));
            }
        };
        getMembers();
    }, [form.designatedFirstAiders, formId]);

    // Attendance Sheet onClick
    const attendanceSheetOnClickHandler = () => {
        navigate(`/attendance/${formId}`, { state: { formId: form.formId } })
    };

    // Safety Audit onClick
    const safetyAuditOnClickHandler = () => {
        navigate(`/safety-audits/${formId}`, { state: { formId: form.formId } })
    };

    // Archive Form Button onClick
    const archiveFormOnClickHandler = async () => {
        setIsLoading(true);
        const newForm = { ...form, isArchived: true };
        setForm(newForm);
        await updateDocByCollectionAndId('Forms', formId, newForm);
        setIsLoading(false);
        navigate('/tailgate-forms');
    };

    // Delete Form Button onClick
    const deleteFormOnClickHandler = async () => {
        setIsLoading(true);
        // await deleteDocByCollectionAndId('Forms', formId);
        await deleteFormAndAllRelatedDocuments(formId, form.team.id !== '')
        setIsLoading(false);
        navigate('/tailgate-forms');
    }

    // Generic Modal Visibilizer
    const modalOnClickHandler = (setIsVisible) => {
        setIsVisible(true)
    };


    // BEGIN: Update Fields to DB

    // Update the passed field in DB
    const updateField = async (fieldName, newValue) => {
        setForm(prevForm => ({...prevForm, [fieldName]: newValue}));
        await updateDocByCollectionAndId('Forms', formId, { [fieldName]: newValue });
    };

    const handleDateChange = (newValue) => updateField('date', newValue);
    const handleTimeChange = (newValue) => updateField('time', newValue);

    const handleLocationChange = async (newValue) => {
        const newForm = {...form, ...newValue};
        setForm(prevForm => ({...prevForm, ...newValue}));
        await updateDocByCollectionAndId('Forms', formId, newForm);
    };

    const handleInstructorsChange = (newValue) => updateField('instructors', newValue);

    const handleTeamChange = async (newValue) => {
        setIsLoading(true);
        setForm(prevForm => ({...prevForm, team: newValue }));
        await updateDocByCollectionAndId('Forms', formId, { team: newValue });
        const teamMembers = await getAllDocsBySubCollection("Teams", newValue.id, "Members");
        await addTeamMembersToFormMembers(formId, teamMembers);

        // Set members for first aiders selector
        if (teamMembers.length > 0) {
            const potentialFirstAiders = teamMembers.map(member => ({
                firstName: member.firstName,
                lastName: member.lastName,
                label: member.firstName + ' ' + member.lastName,
                value: member.id
            }));
            setMembers(potentialFirstAiders);
            setSelectedMembers(potentialFirstAiders.filter(member => form.designatedFirstAiders.includes(member.label)));
        }
        setIsLoading(false);
    };

    const handleSelectedHazardsChange = (newValue) => updateField('hazards', newValue);
    const handleSelectedControlMeasuresChange = (newValue) => updateField('controlMeasures', newValue);

    const handleHazardsWithControlMeasuresChange = async (newHazards, newControlMeasures) => {
        setForm(prevForm => ({...prevForm, controlMeasures: newControlMeasures, hazards: newHazards }));
        await updateDocByCollectionAndId('Forms', formId, { controlMeasures: newControlMeasures, hazards: newHazards });
    };

    const handleFirstAidLocationChange = (newValue) => updateField('firstAidLocation', newValue);

    const handleDesignatedFirstAidersChange = (newValue) => {
        var chosenMembers = '';
        if (newValue.length > 0) {
            newValue.forEach(user => {
                if (chosenMembers.length === 0) {
                    chosenMembers = chosenMembers.concat(user.label);
                } else {
                    chosenMembers = chosenMembers.concat(', ', user.label);
                }
            });
        }
        updateField('designatedFirstAiders', chosenMembers);
    };

    const handleMusterPointChange = (newValue) => updateField('musterPoint', newValue);

    const handleNearestHospitalChange = async (newValue) => {
        setIsLoading(true);
        const eta = await calculateETA(newValue.address);
        if (eta && eta > 0) newValue.eta = eta;
        updateField('nearestHospital', newValue)
        setIsLoading(false);
    };

    const handleSearchAndRescueChange = (newValue) => updateField('searchAndRescue', newValue);
    const handleLocalGovContactChange = (newValue) => updateField('localGovContact', newValue);
    const handleSiteContactChange = (newValue) => updateField('siteContact', newValue);
    const handleNearMissOccurredChange = (newValue) => updateField('nearMissOccurred', newValue);
    const handleIncidentOccurredChange = (newValue) => {
        if (incidents.length > 0 && newValue === false) {
            setDeleteIncidentModalIsVisible(true)
            return;
        }
        updateField('incidentOccurred', newValue)
    };
    const handleNearMissDescriptionChange = (newValue) => updateField('nearMissDescription', newValue);
    const handleNotesChange = (newValue) => updateField('notes', newValue);
    // END: Update Fields to DB

    const handlePhoneClick = (e, number) => {
        e.stopPropagation()
        if (number) {
            window.open(`tel:${number}`, '_self');
        } else {
            window.alert("Please enter a valid number");
        }
    }
    const handleSearchNearest = (e, type, locations) => {
        e.stopPropagation()
        const location = locations.trim() || 'me';
        const searchUrl = `https://www.google.com/maps/search/${type}+near+${encodeURIComponent(location)}`;
        window.open(searchUrl, '_blank');
    }

    const handleCreateIncident = async () => {
        setIsLoading(true)
        const newIncident = {
            createdAt: new Date(),
            lastUpdated: new Date(),
            formId: formId,
            firstName: '',
            lastName: '',
            middleInitial: '',
            studentNumber: '',
            address: '',
            postalCode: '',
            city: '',
            province: '',
            phoneNumber: '',
            schoolDept: '',
            incidentLocationDescription: '',
            incidentDescription: '',
            injuryDescription: '',
            personReportedTo: '',
            supervisorName: '',
            preventedDescription: '',
            explainWasAwarePain: '',
            additionalInfo: '',
            birthDate: '',
            incidentDateTime: '',
            reportedDateTime: '',
            equipmentUsed: '',
            witnesses: '',
            firstAidDate: '',
            firstAidAttendantName: '',
            clinicDate: '',
            phisicianName: '',
            wasEquipmentUsed: null,
            goToClinic: null,
            wereWitnesses: null,
            firstAidReceived: null,
            wasAwarePain: null,
        }
        const newDoc = await createNewDocInDb('Incidents', newIncident)
        navigate(`/incidents/${newDoc.id}`)
    }

    // Method to generate all ERP rows
    const emergencyResponsePlanRows = useMemo(() => {
        // First Aid Location InfoRow
        const firstAidLocation = <InfoRow
            key={FIRST_AID_KIT_LOCATION}
            iconComponent={<MedicalServicesIcon sx={{ height: '30px', width: '30px' }} />}
            title={FIRST_AID_KIT_LOCATION.toUpperCase()}
            mainText={form.firstAidLocation}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setFaLocationModalIsVisible)}
        />;

        // Designated First Aiders InfoRow
        const designatedFirstAiders = <InfoRow
            key={DESIGNATED_FIRST_AIDERS}
            iconComponent={<AccessibilityNewIcon sx={{ color: Colors.yellow, height: '30px', width: '30px' }} />}
            title={DESIGNATED_FIRST_AIDERS.toUpperCase()}
            mainText={form.designatedFirstAiders}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setDesignatedFirstAidersModalIsVisible)} />;

        // Muster Point InfoRow
        const musterPoint = <InfoRow
            key={MUSTER_POINT}
            iconComponent={<LocationOnIcon sx={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            title={MUSTER_POINT.toUpperCase()}
            mainText={form.musterPoint}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setMusterPointModalIsVisible)} />;

        const getHospitalMainText = (hospital) => {
            if (hospital?.eta) return <>{hospital?.name}&nbsp;&nbsp;<DriveEta sx={{ marginBottom: '-6px' }} />{hospital?.eta}min</>
            else return hospital?.name
        }

        // Nearest Hospital InfoRow
        const nearestHospital = <InfoRow
            key={NEAREST_HOSPITAL}
            iconComponent={<LocalHospitalIcon sx={{ color: Colors.red, height: '30px', width: '30px' }} />}
            title={NEAREST_HOSPITAL.toUpperCase()}
            mainText={getHospitalMainText(form.nearestHospital)}
            subText={form.nearestHospital.address}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setNearestHospitalModalIsVisible)}
            icon={<DirectionsIcon style={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            iconClickHandler={(e) => handleSearchNearest(e, 'hospitals', form.nearestHospital.address)}
        />;

        // Search and Rescue InfoRow
        const searchAndRescue = <InfoRow
            key={SEARCH_AND_RESCUE}
            iconComponent={<ContactEmergencyIcon sx={{ color: Colors.red, height: '30px', width: '30px' }} />}
            title={`EMERGENCY CONTACT (optional)`}
            mainText={form.searchAndRescue.name}
            subText={form.searchAndRescue.phone}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setSearchAndRescueModalIsVisible)}
            icon={<PhoneIcon style={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            iconClickHandler={(e) => handlePhoneClick(e, form.searchAndRescue.phone)} />;

        // Local Government Contact InfoRow
        const localGovContact = <InfoRow
            key={LOCAL_GOV_CONTACT}
            iconComponent={<ContactEmergencyIcon sx={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            title={`${LOCAL_GOV_CONTACT.toUpperCase()} (optional)`}
            mainText={form.localGovContact.name}
            subText={form.localGovContact.phone}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setLocalGovContactModalIsVisible)}
            icon={<PhoneIcon style={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            iconClickHandler={(e) => handlePhoneClick(e, form.localGovContact.phone)} />;

        // Site Contact InfoRow
        const siteContact = <InfoRow
            key={SITE_CONTACT}
            iconComponent={<ContactEmergencyIcon sx={{ color: Colors.green, height: '30px', width: '30px' }} />}
            title={SITE_CONTACT.toUpperCase()}
            mainText={form.siteContact.name}
            subText={form.siteContact.phone}
            isEditable={!form.isArchived}
            onClickHandler={() => modalOnClickHandler(setSiteContactModalIsVisible)}
            icon={<PhoneIcon style={{ color: Colors.blue, height: '30px', width: '30px' }} />}
            iconClickHandler={(e) => handlePhoneClick(e, form.siteContact.phone)} />;

        const rows = [firstAidLocation, designatedFirstAiders, musterPoint,
            nearestHospital, siteContact, searchAndRescue, localGovContact];
        return rows;
    }, [form]);

    return (
        <Stack>
            <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ marginTop: '50px' }}>
                <Alert severity="info" sx={{ width: '100%' }}>
                    This form is archived or you do not have permission to edit it.
                </Alert>
            </Snackbar>
            {/* Loading Spinner for async */}
            {isLoading && <LoadingSpinner isLoading={isLoading} />}

            {/* General Form Details */}
            <Box>
                {/* Date */}
                <InfoRow
                    iconComponent={<CalendarMonthIcon sx={{ height: '30px', width: '30px' }} />}
                    title={DATE.toUpperCase()}
                    mainText={form.date}
                    isEditable={!form.isArchived}
                    onClickHandler={() => modalOnClickHandler(setDateModalIsVisible)} />
                <DateSelector
                    isVisible={dateModalIsVisible}
                    setIsVisible={setDateModalIsVisible}
                    dataCallback={handleDateChange} />
                <Divider />

                {/* Time */}
                <InfoRow
                    iconComponent={<AccessTimeIcon sx={{ color: Colors.yellow, height: '30px', width: '30px' }} />}
                    title={START_TIME.toUpperCase()}
                    mainText={form.time}
                    isEditable={!form.isArchived}
                    onClickHandler={() => modalOnClickHandler(setTimeModalIsVisible)} />
                <TimeSelector
                    isVisible={timeModalIsVisible}
                    setIsVisible={setTimeModalIsVisible}
                    dataCallback={handleTimeChange} />
                <Divider />

                {/* Location */}
                <InfoRow
                    iconComponent={<LocationOnIcon sx={{ color: Colors.blue, height: '30px', width: '30px' }} />}
                    title={LOCATION.toUpperCase()}
                    mainText={form.locationName}
                    isEditable={!form.isArchived}
                    onClickHandler={() => modalOnClickHandler(setLocationModalIsVisible)} />
                <LocationModal
                    defaultValue={form.locationName}
                    isVisible={locationModalIsVisible}
                    setIsVisible={setLocationModalIsVisible}
                    dataCallback={handleLocationChange}
                    isAdmin={isAdmin} />
                <Divider />

                {/* Instructors */}
                <InfoRow
                    iconComponent={<SupervisorAccountIcon sx={{ color: Colors.black, height: '30px', width: '30px' }} />}
                    title={INSTRUCTORS.toUpperCase()}
                    mainText={form.instructors?.join(', ')}
                    isEditable={!form.isArchived}
                    onClickHandler={() => modalOnClickHandler(setInstructorsModalIsVisible)} />
                <InstructorsModal
                    isVisible={instructorsModalIsVisible}
                    setIsVisible={setInstructorsModalIsVisible}
                    title={INSTRUCTORS}
                    mainActionHandler={handleInstructorsChange}
                    initialInstructors={form.instructors} />
                <Divider />


                {/* Team */}
                <InfoRow
                    iconComponent={<GroupsIcon sx={{ color: Colors.green, height: '30px', width: '30px' }} />}
                    title={'TEAM'}
                    mainText={form.team.name}
                    isEditable={!form.isArchived}
                    onClickHandler={() => modalOnClickHandler(setTeamModalIsVisible)} />
                <TeamModal
                    userId={form.userId}
                    defaultValue={form.team}
                    isVisible={teamModalIsVisible}
                    setIsVisible={setTeamModalIsVisible}
                    dataCallback={handleTeamChange} />
                <Divider />
            </Box>

            {/* General Notes */}
            <Container sx={{ marginTop: '12px' }}>
                <MultilineInput
                    label={'General Notes'}
                    placeholder={'Enter general notes about your trip here...'}
                    value={form.notes}
                    disabled={form.isArchived}
                    setText={handleNotesChange}
                    debounceSetText={true} />
            </Container>

            <Divider />

            <Box
                sx={{
                    marginTop: '5%',
                    marginBottom: '16px',
                    display: "flex",
                    justifyContent: "center",
                    gap: '15px',
                    flexWrap: 'wrap',
                }} >

                {/* Attendance Sheet */}
                <ModalButton
                    fontSize={'1.2rem'}
                    color={Colors.green}
                    onClick={attendanceSheetOnClickHandler}>
                    Attendance Sheet
                </ModalButton>

                {/* Safety Audits */}
                <ModalButton
                    fontSize={'1.2rem'}
                    color={Colors.blue}
                    onClick={safetyAuditOnClickHandler}>
                    Safety Audits
                </ModalButton>

            </Box>
            <Divider />

            {/* Hazards */}
            <Box>
                <h3>{HAZARDS}</h3>
                <HazardsAccordion
                    isEditable={!form.isArchived}
                    hazardsList={allHazards}
                    setHazardsList={setAllHazards}
                    selectedHazards={form.hazards}
                    setSelectedHazards={handleSelectedHazardsChange}
                    selectedControlMeasures={form.controlMeasures}
                    setSelectedHazardsAndControlMeasures={handleHazardsWithControlMeasuresChange} />
            </Box>

            {/* Control Measures */}
            <Box>
                <h3>{CONTROL_MEASURES}</h3>
                <ControlMeasuresAccordion
                    isEditable={!form.isArchived}
                    controlMeasuresList={allControlMeasures}
                    setControlMeasuresList={setAllControlMeasures}
                    selectedControlMeasures={form.controlMeasures}
                    setSelectedControlMeasures={handleSelectedControlMeasuresChange} />
            </Box>

            {/* Emergency Response Plan */}
            <InfoContainer
                title={EMERGENCY_RESPONSE_PLAN}
                infoRows={emergencyResponsePlanRows}
                showEditIcon={false} />

            {/* First Aid Location Modal */}
            <SingleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                inputLabel={FIRST_AID_KIT_LOCATION}
                defaultValue={form.firstAidLocation}
                isVisible={faLocationModalIsVisible}
                setIsVisible={setFaLocationModalIsVisible}
                dataCallback={handleFirstAidLocationChange} />

            {/* Designated First Aiders Modal */}
            <EditMembersModal
                title={EMERGENCY_RESPONSE_PLAN}
                inputLabel={DESIGNATED_FIRST_AIDERS}
                isVisible={designatedFirstAidersModalIsVisible}
                setIsVisible={setDesignatedFirstAidersModalIsVisible}
                dataCallback={handleDesignatedFirstAidersChange}
                options={members}
                defaultSelected={selectedMembers}
                showSelectAll={false} />

            {/* <SingleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                inputLabel={DESIGNATED_FIRST_AIDERS}
                defaultValue={form.designatedFirstAiders}
                isVisible={designatedFirstAidersModalIsVisible}
                setIsVisible={setDesignatedFirstAidersModalIsVisible}
                dataCallback={handleDesignatedFirstAidersChange} /> */}

            {/* Muster Point Modal */}
            <SingleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                inputLabel={MUSTER_POINT}
                defaultValue={form.musterPoint}
                isVisible={musterPointModalIsVisible}
                setIsVisible={setMusterPointModalIsVisible}
                dataCallback={handleMusterPointChange} />

            {/* Nearest Hospital Modal */}
            <DoubleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                modalSubLabel={NEAREST_HOSPITAL}
                firstInputLabel={NAME}
                secondInputLabel={ADDRESS}
                firstDefaultValue={form.nearestHospital.name}
                secondDefaultValue={form.nearestHospital.address}
                firstInputName={NAME.toLowerCase()}
                secondInputName={ADDRESS.toLowerCase()}
                isVisible={nearestHospitalModalIsVisible}
                setIsVisible={setNearestHospitalModalIsVisible}
                dataCallback={handleNearestHospitalChange} />

            {/* Search and Rescue Modal */}
            <DoubleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                modalSubLabel={SEARCH_AND_RESCUE}
                firstInputLabel={NAME}
                secondInputLabel={PHONE}
                firstDefaultValue={form.searchAndRescue.name}
                secondDefaultValue={form.searchAndRescue.phone}
                firstInputName={NAME.toLowerCase()}
                secondInputName={PHONE.toLowerCase()}
                isVisible={searchAndRescueModalIsVisible}
                setIsVisible={setSearchAndRescueModalIsVisible}
                dataCallback={handleSearchAndRescueChange} />

            {/* Local Government Contact Modal */}
            <DoubleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                modalSubLabel={LOCAL_GOV_CONTACT}
                firstInputLabel={NAME}
                secondInputLabel={PHONE}
                firstDefaultValue={form.localGovContact.name}
                secondDefaultValue={form.localGovContact.phone}
                firstInputName={NAME.toLowerCase()}
                secondInputName={PHONE.toLowerCase()}
                isVisible={localGovContactModalIsVisible}
                setIsVisible={setLocalGovContactModalIsVisible}
                dataCallback={handleLocalGovContactChange} />

            {/* Site Contact Modal */}
            <DoubleTextInputModal
                modalLabel={EMERGENCY_RESPONSE_PLAN}
                modalSubLabel={SITE_CONTACT}
                firstInputLabel={NAME}
                secondInputLabel={PHONE}
                firstDefaultValue={form.siteContact.name}
                secondDefaultValue={form.siteContact.phone}
                firstInputName={NAME.toLowerCase()}
                secondInputName={PHONE.toLowerCase()}
                isVisible={siteContactModalIsVisible}
                setIsVisible={setSiteContactModalIsVisible}
                dataCallback={handleSiteContactChange} />

            {/* Near Miss */}
            <h3>Near-Misses</h3>
            <Stack
                style={{
                    display: 'flex',
                    alignItems: 'start',
                    backgroundColor: Colors.white,
                    padding: 5,
                    borderRadius: '8px',
                    border: `1px solid ${Colors.red}`,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
                }} >
                <Container>
                    <CheckboxWithConfirmation
                        disabled={form.isArchived}
                        checked={form.nearMissOccurred}
                        setChecked={handleNearMissOccurredChange}
                        label={NEAR_MISS}
                        modalText={`Did a Near Miss occur?`} >
                        <Typography
                            sx={{ fontSize: '1.1rem', fontFamily: 'Jost', marginLeft: '10px' }}>
                            Did a <span style={{ fontWeight: 'bold' }}>{NEAR_MISS}</span> occur?
                        </Typography>
                    </CheckboxWithConfirmation>
                    {form.nearMissOccurred && <MultilineInput
                        label={NEARMISS_PLACEHOLDER}
                        maxChars={2500}
                        value={form.nearMissDescription}
                        setText={handleNearMissDescriptionChange}
                        debounceSetText={true} />}
                </Container>
            </Stack>

            {/* Incidents */}
            <h3>Incidents</h3>
            <Stack
                style={{
                    display: 'flex',
                    alignItems: 'start',
                    backgroundColor: Colors.white,
                    padding: 5,
                    borderRadius: '8px',
                    marginBottom: "16px",
                    border: `1px solid ${Colors.red}`,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
                }} >
                <Container sx={{ marginTop: '8px', marginBottom: '8px' }}>
                    <CheckboxWithConfirmation
                        disabled={form.isArchived}
                        checked={form.incidentOccurred}
                        setChecked={handleIncidentOccurredChange}
                        label={INCIDENT}
                        modalText={`Did an Incident occur?`} >
                        <Typography
                            sx={{ fontSize: '1.1rem', fontFamily: 'Jost', marginLeft: '10px' }}>
                            Did an <span style={{ fontWeight: 'bold' }}>{INCIDENT}</span> occur?
                        </Typography>
                    </CheckboxWithConfirmation>
                </Container>
                {form.incidentOccurred &&
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', width: '100%', marginBottom: '15px', marginTop: '10px' }}>
                        {incidents.map((incident, index) => (
                            <SimpleRowCard
                                disabled={form.isArchived}
                                key={'incident' + index}
                                label={incident.createdAt.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                icon={<Report sx={{ color: Colors.red, fontSize: 26 }} />}
                                onClick={() => navigate('/incidents/' + incident.id)}
                            />
                        ))}
                        {!form.isArchived &&
                            <PlusIconButton color={Colors.red} size={'1.5rem'} onClick={handleCreateIncident} />
                        }
                    </div>
                }
            </Stack>


            {/* Fake Save & Close Button */}
            {!form.isArchived && <Box sx={{
                marginTop: '5%',
                display: "flex",
                justifyContent: "center"
            }} >
                <Button
                    color={Colors.green}
                    onClick={() => navigate('/tailgate-forms')}>
                    Save & Close
                </Button>
            </Box>}
            {/* Archive Button */}
            {!form.isArchived && <Box sx={{
                marginTop: '5%',
                display: "flex",
                justifyContent: "center"
            }} >
                <Button
                    color={Colors.orange}
                    onClick={() => modalOnClickHandler(setArchiveModalIsVisible)}>
                    Archive Form
                </Button>
            </Box>}

            {/* Archive Modal */}
            <ConfirmationModal
                isVisible={archiveModalIsVisible}
                setIsVisible={setArchiveModalIsVisible}
                title={<>
                    <span style={{ color: Colors.red }}>WARNING: </span>
                    <span>This action is </span>
                    <span style={{ color: Colors.red }}>PERMANENT</span>
                    <span> and </span>
                    <span style={{ color: Colors.red }}>IRREVERSIBLE</span>
                    <span>.</span>
                    <br />
                    <span>Would you like to submit this form as complete and permanently archive this form?</span>
                </>}
                mainAction={'Archive'}
                mainActionHandler={archiveFormOnClickHandler}
                color={Colors.orange} />

            {/* Delete Button */}
            {!form.isArchived && <Box
                sx={{
                    marginTop: '5%',
                    display: "flex",
                    justifyContent: "center"
                }} >
                <Button
                    color={Colors.red}
                    onClick={() => modalOnClickHandler(setDeleteModalIsVisible)}>
                    Delete Form
                </Button>
            </Box>}

            {/* Delete Modal */}
            <ConfirmationModal
                isVisible={deleteModalIsVisible}
                setIsVisible={setDeleteModalIsVisible}
                title={'Permanently Delete this form and its saved data?'}
                mainAction={'Delete'}
                mainActionHandler={deleteFormOnClickHandler} />

            <ModalContainer title={"Could Not Perform Action"} isVisible={deleteIncidentModalIsVisible} setIsVisible={setDeleteIncidentModalIsVisible} style={{ paddingRight: '30px', paddingLeft: '30px' }}>
                <span>You must delete existing incidents before unchecking this button.</span>
                <ModalButton color={Colors.gray} onClick={() => setDeleteIncidentModalIsVisible(false)}>Okay</ModalButton>
            </ModalContainer>
        </Stack>
    )
};

export default EditForm;